import Fondo from "../assets/people.png";
import { motion } from "framer-motion";

const QuienesSomos = () => {
  return (
    <div className="w-full h-auto md:h-screen md:flex">
      <motion.div
        className="w-full md:w-1/2"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <img
          src={Fondo}
          alt="Quienes Somos"
          className="h-full w-auto object-contain"
        />
      </motion.div>
      <motion.div
        className="w-full md:w-1/2 flex flex-col justify-center px-6 md:px-16 gap-6"
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <h1 className="text-4xl md:text-6xl font-bold text-purple-900">
          Sobre Nosotros
        </h1>
        <p className="text-gray-600 text-base md:text-lg text-justify">
          Somos una empresa de Abogados y Contadores especializados en Materia Tributaria,
          Contabilidad y Auditoría, además del Litigio en Materia Fiscal, Mercantil, Civil,
          Laboral, Corporativo, Administrativo, cuyo objetivo fundamental es lograr la excelencia
          en la prestación de dichos servicios, dirigidos principalmente a particulares,
          pequeñas, medianas y grandes empresas que requieran de atención especializada y profesional.
        </p>
      </motion.div>
    </div>
  );
};

export default QuienesSomos;
